import 'jquery-nice-select';
import stickybits from 'stickybits';
import get from 'lodash.get';
import { getUrlParameter } from '../helpers/url';

export default class Subscription {
  constructor() {
    this.$form = $('#subscription-form');
    this.$select = this.$form.find('.subscription-input-select');
    this.$priceSummary = $('.subscription-summary-text');
    this.$priceSummary.data('defaultText', this.$priceSummary.text());
    this.templateData = {
      recipient: 'Me',
      quantity: '1 bag',
      shipping: 'Every 4 Weeks',
      billing: 'Ongoing',
    };
    this.roasts = ['Dark', 'Medium', 'Limited'];
    
    this._init();
    this._bindEvents();
    this._resetProducts();
    this._compileTemplate(this.templateData, {});
    this._setInitialState();
  }

  /**
   *
   * Initial setup.
   * Parse subscription IDs from liquid
   * Set up jQuery plugins
   *
   */
  _init() {
    const json = document.getElementById('subscription-ids');

    this.$select.niceSelect();
    stickybits('.subsection-heading-title', {
      useStickyClasses: true,
      stickyBitStickyOffset: 59,
    });

    if (!json) return;
    this.subscriptionIds = JSON.parse(json.innerHTML);
  }

  _setInitialState() {
    const param = 'recipient';
    const recipient = getUrlParameter(param);
    if (!recipient) return;
    $(`input[name="${param}"][value="${recipient}"]`).prop('checked', true);
    this.$form.trigger('change');
  }

  /**
   *
   * Add listeners to the form events
   *
   */
  _bindEvents() {
    this.$form.on('change', this._handleChange.bind(this));
    this.$form.on('submit', this._addToCart.bind(this));
    this.$select.on('change', this._handleSelectChange.bind(this));
  }
  
  /**
   *
   * Reset the list of products to be added
   *
   */
  _resetProducts() {
    this.products = [];
  }
  
  /**
   *
   * Callback for the form change event
   *
   */
  _handleChange(event) {
    const formData = this._parseFormData($(event.currentTarget).serializeArray());
    const productHandle = this._convertDataToHandle(formData);

    this._compileTemplate(this._prepareTemplateData(formData), formData);

    if (!productHandle) return;

    this._resetProducts();
    this._getProductByHandle(productHandle)
      .then((response => {
        const { product } = response;
        const variants = this._getSelectedVariantQty(formData, product);

        this._setProducts(formData, variants, product);
        this._applyPriceTemplate(product, variants, formData);
        this._validateForm(formData);
      }));
  }

  _handleSelectChange(event) {
    const value = event.target.value;
    
    $(event.target).closest('.subscription-input-group').toggleClass('is-active', !!value);
  }

  /**
   *
   * Converts an array of form input objects
   * to a flat object for easier manipulation.
   * @param {array} dataArray An array of form input name:value objects
   * @returns {object} the form data
   *
   */
  _parseFormData(dataArray) {
    const formData =  dataArray.reduce((object, item) => (object[item.name] = item.value, object), {});
    // Remove empty properties (For when selects have no value)
    Object.keys(formData).forEach((key) => (formData[key] === '') && delete formData[key]);
    return formData;
  }

  /**
   *
   * Build a product handle
   * @param {object} data The form data
   * @returns {string} The handle
   *
   */
  _convertDataToHandle(data) {
    if (!data.billing || !data.shipping) return false;
    if (data.billing === 'monthly') return data.billing;
    return `${data.billing}-${data.shipping}`;
  }

  /**
   *
   * Get a product's JSON by its handle
   * @param {string} handle The product handle
   * @returns {Promise} jqXHR object
   *
   */
  _getProductByHandle(handle) {
    return $.get(`/products/${handle}.json`);
  }

  /**
   *
   * Get a subscription ID from a product ID
   * @param {int} productId The product associated with the subscription
   *
   */
  _getSubscriptionId(productId) {
    return this.subscriptionIds[productId];
  }

  /**
   *
   * Get the IDs of any selected variants.
   * (When billing or shipping freq changes, variants will change)
   * @param {object} formData The currently selected options
   * @param {object} product The product associated with the selected billing & shipping options
   * @returns {array} Objects with variant ids and quantities
   *
   */
  _getSelectedVariantQty(formData, product) {
    return product.variants
      .filter(variant => variant.title in formData)
      .map(variant => {
        return {
          id: parseInt(variant.id, 10),
          quantity: parseInt(formData[variant.title], 10),
          price: parseFloat(variant.price),
        };
      });
  }

  /**
   *
   * Convert the shipping frequency string to a number of weeks
   * @param {string} unit The frequency text
   * @returns {string} The frequency number
   *
   */
  _parseShippingFrequency(unit) {
    const frequency = {
      'weekly': '1',
      'biweekly': '2',
      'monthly': '4',
    };
    return frequency[unit];
  }

  /**
   *
   * Set the product variants that will be added to cart
   * @param {object} formData The currently selected options
   * @param {array} variants Objects with id and quantity
   * @param {object} product The parent product of the variants
   *
   */
  _setProducts(formData, variants, product) {
    variants.forEach(variant => this.products.push(
      this._buildATCObject(
        variant.id,
        variant.quantity,
        this._parseShippingFrequency(formData.shipping),
        this._getSubscriptionId(product.id),
        formData.recipient
      )
    ));
  }
  
  /**
   *
   * Build out the ATC object with properties needed by Recharge
   * @param {int} id The variant ID
   * @param {int} quantity The quantity of each variant to add
   * @param {string} interval The shipping interval
   * @param {string} subscription The subscription ID associated with this product
   * @param {string} unit The shipping interval unit
   * @returns {object} The subscription data to be added to cart
   *
   */
  _buildATCObject(id, quantity, interval, subscription, recipient, unit = 'Weeks') {
    return {
      id,
      quantity,
      properties: {
        shipping_interval_frequency: interval,
        shipping_interval_unit_type: unit,
        subscription_id: subscription,
        recipient
      }
    };
  }
  
  /**
   *
   * Validate each group of form fields
   * @param {object} formData The currently selected options
   *
   */
  _validateForm(formData) {
    const selectedOptions = Object.keys(formData);
    const $validationGroups = this.$form.find('[data-validation-group]');
    const groupValidity = [];

    $validationGroups.each((index, group) => {
      const names = $(group).find('[name]').map((index, element) => {
        return element.name;
      }).get();

      // Take all group `[name]` values and see if any are in selectedOptions
      groupValidity.push(names.some(name => selectedOptions.includes(name)));
    });

    const isValid = groupValidity.every(validity => validity);
    this.$form
      .find('.button-atc')
      .toggleClass('is-valid', isValid)
      .prop('disabled', !isValid);
  }

  /**
   *
   * Queue all subscription products/variants
   * and add them to the cart
   * @param {object} event The form submit event
   *
   */
  _addToCart(event) {
    event.preventDefault();

    const requests = this.products.map(product => this._buildAtcRequest(product));
    const sendAtcRequests = () => {
      if (requests.length) {
        $.post(requests.shift(), sendAtcRequests);
      } else {
        document.location.href = '/cart';
      }
    }
    
    sendAtcRequests();
  }
  
  /**
   *
   * Send an add to cart request
   * @param {object} product The product with line items to add
   *
   */
  _buildAtcRequest(product) {
    return {
      url: '/cart/add.js',
      dataType: 'json',
      data: product,
    };
  }

  /**
   *
   * Format the template string for
   * the recipient block
   * @param {object} recipient The currently selected recipient options
   * @returns {string} The recipient template string
   *
   */
  _parseTeplateRecipient(recipient) {
    return recipient === 'me' ? 'Me' : 'A Friend';
  }

  /**
   *
   * Format the template string for
   * the quantity block
   * @param {object} formData The currently selected form options
   * @returns {string} The quantity template string
   *
   */
  _parseTemplateQuantity(formData) {
    let qty = 0;
    this.roasts.forEach(roast => {
      qty += parseInt(get(formData, roast, 0), 10);
    });
    
    return qty < 2 ? `${qty} bag` : `${qty} bags`;
  }

  /**
   *
   * Format the template string for
   * the shipping block
   * @param {object} shipping The currently selected shipping options
   * @returns {string} The shipping template string
   *
   */
  _parseTemplateShipping(shipping) {
    const frequency = {
      'weekly': 'Every Week',
      'biweekly': 'Every 2 Weeks',
      'monthly': 'Every 4 Weeks',
    };
    return frequency[shipping];
  }

  /**
   *
   * Format the template string for
   * the billing block
   * @param {object} billing The currently selected billing options
   * @returns {string} The billing template string
   *
   */
  _parseTemplateBilling(billing) {
    const frequency = {
      'monthly': 'Ongoing',
      '3-month': 'for 3 Months',
      '6-month': 'for 6 Months',
      '12-month': 'for 1 Year',
    };
    return frequency[billing];
  }

  
  /**
   *
   * Convert the form data into template strings
   * @param {object} formData The currently selected form options
   * @returns {object} The updated template strings
   *
   */
  _prepareTemplateData(formData) {
    for (let property in formData) {
      if (this.roasts.includes(property)) {
        this.templateData.quantity = this._parseTemplateQuantity(formData);
      }

      if (property === 'recipient') {
        this.templateData.recipient = this._parseTeplateRecipient(formData.recipient);
      }

      if (property === 'shipping') {
        this.templateData.shipping = this._parseTemplateShipping(formData.shipping);
      }
      
      if (property === 'billing') {
        this.templateData.billing = this._parseTemplateBilling(formData.billing);
      }
    }

    return this.templateData;
  }
  
  /**
   *
   * Inject the strings into the template
   *
   */
  _compileTemplate(templateData, formData) {
    $('.subscription-progress-item').each((index, element) => {
      const field = $(element).attr('data-progress');
      const isActive = field => {
        // Check if formData keys contain a roast to determine if quantity field isActive.
        // Otherwise check if formData keys contain field.
        return field === 'quantity'
          ? this.roasts.some(roast => Object.keys(formData).includes(roast))
          : field in formData;
      }
      
      $(element)
        .html(templateData[field])
        .toggleClass('is-active', isActive(field));
    });
  }

  /**
   *
   * Get the unit price from the product meta json
   * @param {object} product The currently selected product
   * @returns {string} The unit price
   *
   */
  _parseBagPrice(product) {
    const json = document.getElementById('unit-prices');
    if (!json) return false;

    const prices = JSON.parse(json.innerHTML);
    return prices[product.id];
  }
  
  /**
   *
   * Get the total quantity of items in the order
   * @param {array} variants The currently selected variants
   * @returns {string} The order quantity
   *
   */
  _parseOrderQuantity(variants) {
    return variants
      .map(variant => variant.quantity)
      .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  }

  /**
   *
   * Calculate the total order price
   * @param {array} variants The currently selected variants
   * @returns {string} The order price
   *
   */
  _parseOrderPrice(variants) {
    const price = variants
      .reduce((accumulator, variant) =>
        accumulator + (variant.quantity * variant.price), 0);

    return price.toFixed(2);
  }

  /**
   *
   * Get the number of deliveries in an order
   * @param {object} formData The currently selected form options
   * @returns {int}
   *
   */
  _parseDeliveries(formData) {
    const shipping = {
      'weekly': 1,
      'biweekly': 2,
      'monthly': 4,
    };
    const billing = {
      '3-month': 12,
      '6-month': 24,
      '12-month': 52,
    };

    return formData.billing === 'monthly'
      ? 1
      : billing[formData.billing] / shipping[formData.shipping];
  }
  
  /**
   *
   * Test if all selected variant
   * prices are the same or not
   * @param {object} variants The currently selected variants
   * @returns {bool}
   *
   */
  _variantPricesDiffer(variants) {
    return !variants
      .map(variant => variant.price)
      .every((value, index, array) => value === array[0]);
  }

  /**
   *
   * Compile the price summary template
   * @param {object} product The currently selected product
   * @param {array} variants The currently selected variants
   * @param {object} formData The currently selected form options
   *
   */
  _applyPriceTemplate(product, variants, formData) {
    const $total = $('.subscription-summary-total');
    const orderPrice = this._parseOrderPrice(variants);
    const deliveries = this._parseDeliveries(formData);
    const quantity = this._parseOrderQuantity(variants);
    const bagPrice = (orderPrice/deliveries/quantity).toFixed(2);
    const averageText = this._variantPricesDiffer(variants) ? 'Avg.' : '';
    
    const bagPriceString = quantity > 0
      ? `$${bagPrice}/Bag ${averageText} | `
      : '';
    
      const orderPriceString = quantity > 0
      ? formData.billing === 'monthly'
        ? `$${orderPrice} Billed ${this._parseTemplateShipping(formData.shipping)}`
        : `${deliveries} Deliveries | $${orderPrice} Pre-Paid`
      : this.$priceSummary.data('defaultText');

    $total.text(bagPriceString);
    this.$priceSummary.text(orderPriceString);
  }
}
